import { useEffect, useRef, useState } from 'react';

import { TZDate } from '@date-fns/tz';
import { intervalToDuration, isBefore } from 'date-fns';

export function useCountdownInterval(targetDate: TZDate) {
  const intervalRef = useRef<number | null>(null);
  const [now, setNow] = useState<Date>(new Date());
  const tzNow = new TZDate(now, targetDate.timeZone);
  const hasTargetDateElapsed = isBefore(targetDate, tzNow);
  /*
    Note: this will only be set to true if the countdown has counted down to zero
    during the lifecycle of the hook NOT if the target date has already elapsed
    when the the hook is called for the first time
  */
  const [countdownComplete, setCountdownComplete] = useState(false);

  useEffect(() => {
    if (!hasTargetDateElapsed) {
      intervalRef.current = window.setInterval(() => {
        setNow(new Date());
      }, 1000);
      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    }
  }, []);

  useEffect(() => {
    if (hasTargetDateElapsed && intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
      setCountdownComplete(true);
    }
  }, [hasTargetDateElapsed]);

  const interval = hasTargetDateElapsed
    ? {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
      }
    : intervalToDuration({
        start: tzNow,
        end: targetDate,
      });
  return { interval, countdownComplete };
}
